import { TenantLifecycleModal } from 'TenantModule/components/TenantLifecycleModal';
import { useDynamicModal } from 'components/DynamicModalProvider/useDynamicModal';
import { useCallback } from 'react';

export const useTenantLifecycleModal = () => {
  const { openModal } = useDynamicModal();

  const openTenantLifecycleModal = useCallback(
    (args: { tenantId: number; onTenantChanged?: VoidFunction }) => {
      openModal({
        modal: ({ isOpen: _isOpen, toggle }) => {
          return <TenantLifecycleModal onClose={toggle} {...args} />;
        },
      });
    },
    [openModal],
  );

  return {
    openTenantLifecycleModal,
  };
};
